import { render, staticRenderFns } from "./ProxySettings.vue?vue&type=template&id=3a983e95&"
import script from "./ProxySettings.vue?vue&type=script&lang=ts&"
export * from "./ProxySettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports